export default "https://cdn-static.gokick.com/assets/b944ecdade3ab4b24738bd1fcec1eea00d00fb75/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";